import { FC, useContext } from "react"

/** Components */
import { SideRailContext } from "../../SideRail/SideRailContext"
/** Types */
import { iCompanyFormSchema } from "../../../cached-data/types"
import { ResourceObject } from "../../../dashboard-data/types"

type Props = {
    data: ResourceObject<iCompanyFormSchema>
}

export const SchemaEditorButtonCellRenderer: FC<Props> = ({ data }) => {
    const { enableSideRail } = useContext(SideRailContext)

    const startSchemaEditorFlow = () => {
        if (data.id) {
            enableSideRail({
                flow: "SCHEMA_EDITOR",
                schemaId: data.id,
            })
        }
    }

    return (
        <button onClick={startSchemaEditorFlow} type="button" className="action-button">
            <div>Edit Schema</div>
        </button>
    )
}

export default SchemaEditorButtonCellRenderer
